import { API } from '@/api'

export const getCurrencies = () => API.get('/currencies/');
